import { Customer } from '@/models/customer';

/**
 * Returns a list of Customer objects based on a list of ids
 * @param {number[]} customerIds Array of customer ids
 * @param {Object} customersKeyedById Customers list converted to object keyed by customer id
 * @returns {Customer[]}
 */
export const buildEligibleBuyers = (customerIds: number[], customersKeyedById: object) => {
  const eligibleBuyers: Customer[] = [];

  customerIds.forEach((id) => {
    if (customersKeyedById[id]) {
      eligibleBuyers.push(customersKeyedById[id]);
    }
  });

  return eligibleBuyers;
};

export interface CustomerParsed extends Customer {
  isPaymentsEnabledForPartner?: boolean | null;
}

/**
 * @deprecated no longer necessary when using the new `getCustomerList`
 * or `getCustomerRecordById` API methods
 * TODO - remove once legacy API methods are removed
 */
export function parseCustomers(customers: Customer[] | Customer): CustomerParsed[] | Customer {
  if (Array.isArray(customers)) {
    return customers.map((customer) => {
      return {
        ...customer,
        isPaymentsEnabledForPartner: customer.partnerEnablePaymentsDirect || customer.partnerEnablePaymentsFlexible,
      };
    }) as CustomerParsed[];
  }

  return customers as Customer;
}
